export const FEEDBACK_MESSAGES = {
  error: "Error trying to send link with instructions. Please try again.",
  success:
    "You will receive an email with instructions for resetting your password shortly."
};
